import {
  School,
  Stars,
  Science,
  Business,
  Brush,
  FitnessCenter,
  Restaurant,
  MusicNote,
  Code,
  Gavel,
  LocalHospital,
  Public,
  TrendingUp,
  AttachMoney,
  Forum,
  MenuBook,
  Psychology,
  MoreHoriz,
} from '@mui/icons-material';

export const roles = [
  { label: 'Teacher', icon: School, color: '#4caf50' },
  { label: 'Celebrity', icon: Stars, color: '#ff9800' },
  { label: 'Scientist', icon: Science, color: '#2196f3' },
  { label: 'Entrepreneur', icon: Business, color: '#9c27b0' },
  { label: 'Artist', icon: Brush, color: '#e91e63' },
  { label: 'Fitness Coach', icon: FitnessCenter, color: '#ff5722' },
  { label: 'Chef Expert', icon: Restaurant, color: '#795548' },
  { label: 'Musician', icon: MusicNote, color: '#673ab7' },
  { label: 'Tech Expert', icon: Code, color: '#00bcd4' },
  { label: 'Legal Professional', icon: Gavel, color: '#607d8b' },
  { label: 'Medical Professional', icon: LocalHospital, color: '#f44336' },
  { label: 'Other Professional', icon: Public, color: '#3f51b5' },
];

export const purposes = [
  { label: 'Scale my expertise and reach more people', icon: TrendingUp },
  { label: 'Monetize my knowledge and content', icon: AttachMoney },
  { label: 'Engage with my audience 24/7', icon: Forum },
  { label: 'Preserve and share my knowledge', icon: MenuBook },
  { label: 'Explore AI technology', icon: Psychology },
  { label: 'Other', icon: MoreHoriz },
];
